import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossDeltaShekelMarketFetch } from './actions';

export const sagasReportGrossDeltaShekelMarket = [
  takeLatest(actionReportGrossDeltaShekelMarketFetch.rejected, workerErrorNotifyThunk),
];
